<div class="card mb-5">
	<div class="card-header">
		<h3>Registrar Depreciación</h3>
	</div>
	<div class="card-body">
		<div class="row">
			<div class="col" id="list-container">
				<div class="row" style="margin-top: 1em;" id="options-other-filters">
					<div class="col-sm form-group">
						<label for="filterVendors" class="form-label">Buscar valor en los campos</label>
						<div class="input-group">
							<input type="text" id="filterVendors" [(ngModel)]="search"
								placeholder="Ingresa Código, nombre, encargador..." name="filterVendors"
								class="form-control">
							<button class="btn btn-primary" (click)="searching()">
								<i class="fa fa-search"></i>
							</button>
						</div>
					</div>
                    <div class="col-sm form-group">
                        <label for="month-register" class="form-label">Mes de depreciación</label>
                        <div class="input-group">
                            <input class="form-control" type="month" [(ngModel)]="month" />
						</div>
                    </div>
                    <div class="col-sm form-group">
                        <app-loading-button [object]="buttonSave" [logo]="true" [colorLoading]="'white'" (clicked)="registerDepreciation()">
                        </app-loading-button>
                    </div>
				</div>
				<div class="table-responsive" style="margin-bottom: 0; overflow-y: inherit; max-height: none;">
					<table class="table table-striped" style="margin-bottom: 0; margin-top: 10px;">
						<thead>
							<tr class="tr-middle">
								<th class="ta">
									Código
								</th>
								<th class="limit-td">
									Nombre
								</th>
								<th class="ta">
									Encargado
								</th>
								<th class="ta">
									Localización
								</th>
								<th class="ta">
									Costo
								</th>
								<th class="ta">
									Acumulado
								</th>
								<th class="ta">
									Depreciación
								</th>
								<!-- <th>

								</th> -->
							</tr>
						</thead>
						<tbody>
							<ng-container *ngFor="let expense of pagination.filter">
								<tr class="tr-middle">
									<td class="ta">
										{{expense.code}}
									</td>
									<td class="limit-td-100">
										{{expense.name}}
									</td>
									<td class="ta">
										{{expense.asignedName}}
									</td>
									<td class="ta">
										{{expense.localizationName}}
									</td>
									<td class="ta">
										{{expense.cost | currency: 'Q'}}
									</td>
									<td class="ta">
										{{(expense.cost * expense.percentajeDepreciated)  | currency: 'Q'}}
									</td>
									<td class="ta">
                                        {{ expense.percentajeDepreciated * 100 | number: '1.2-2' }}%
                                    </td>
									<!-- <td class="ta">
										<div style="display: flex; justify-content: space-between;">
											<span (click)="detailingInvoice(expense)" title="Ver detalle"
													class="clickeable">
													<i *ngIf="!detailing[expense.id]" class="fa fa-eye"></i>
													<span *ngIf="detailing[expense.id]"
														class="spinner-border spinner-border-sm" aria-hidden="true"></span>
											</span>
										</div>
									</td> -->
								</tr>
							</ng-container>
							<tr *ngIf="pagination.filter.length == 0">
								<td colspan="9" class="ta" style="color: gray">
									<i class="fa fa-circle-info"></i>No se encontraron documentos en las fechas
									seleccionadas
								</td>
							</tr>
						</tbody>
					</table>
				</div>
				<app-pagination-custom [elements]="pagination"></app-pagination-custom>
			</div>
		</div>
	</div>
</div>